import Vue from 'vue'
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'


const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warning: 'warn'
}

miniToastr.init({types: toastTypes})


const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}

Vue.use(VueNotifications, options)

export function toast({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

